import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Kenya suffers from unreliable rains and recurrent droughts. Two consecutive failed rain seasons saw the number of people needing humanitarian assistance rise to 2.6 million across the country in 2019. Life is especially hard for the country’s large refugee population, who are unable to work or move freely and who are highly dependent on international assistance. `}</p>
    <p>{`In the Kalobeyei settlement and nearby camps, WFP is responsible for providing food to refugees on a monthly basis. Last year, thanks to funding from donors like the EU, WFP was able to `}<a parentName="p" {...{
        "href": "https://insight.wfp.org/bamba-chakula-a-saviour-in-times-of-reduced-rations-fd6604b4df44"
      }}>{`provide 420,000 refugees with cash transfers`}</a>{`. Most of them come from farming areas in South Sudan, but many of them were not able to continue farming due to dry spells and the lack of a stable water supply. `}</p>
    <p>{`That is why, in addition to ensuring the most vulnerable had access to adequate food and nutrition, WFP and the EU, together with partners, worked on long-term `}<a parentName="p" {...{
        "href": "https://insight.wfp.org/the-game-changing-water-reservoirs-of-kalobeyei-cb614ba3fa62"
      }}>{`solutions to help tackle drought`}</a>{` – one of the root causes of food insecurity in the country – as well as refugees’ dependence on aid. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      